import {ItemMenu} from '../models/item-menu.model';
import {
	CHANGE_CENTERS_DASHBOARD,
	CLAIMS_REPAIR,
	FIND_CENTERS_DASHBOARD,
	ROOT_ADMINISTRATION_CHANNELING,
	ROOT_ADMINISTRATION_RULES,
	ROOT_ADMINISTRATION_USER_MANAGEMENT,
	ROOT_AUTHORITY,
	ROOT_BOOKINGS,
	ROOT_CLAIMS_ADMIN,
	ROOT_CLAIMS_COMPLAINT,
	ROOT_CLAIMS_OLSA,
	ROOT_CLAIMS_PRACTICE_CAR,
	ROOT_CLAIMS_PRACTICES,
	ROOT_CLAIMS_REPAIR,
	ROOT_CLAIMS_SUPERVISOR,
	ROOT_CLAIMS_THEFT,
	ROOT_CONTRACT_CLOSING_ALD,
	ROOT_CONTRACT_CLOSING_DK_BO,
	ROOT_CONTRACT_CLOSING_DK_C,
	ROOT_CONTRACT_CLOSING_DK_OP,
	ROOT_CONTRACT_CLOSING_SP,
	ROOT_DELIVERY,
	ROOT_DELIVERY_ASR,
	ROOT_FLOTTA_POOL,
	ROOT_INVOICING,
	ROOT_LOGISTICS,
	ROOT_NOTIFICATION_CENTER,
	ROOT_PROFILE,
	ROOT_TYRES,
	ROOT_USER_CHANGE_ALD,
	ROOT_USER_CHANGE_SP,
	ROOT_BOOKINGS_RELIEF, ROOT_CHANGE_CENTER_DELIVERY,
	ROOT_MOBILITY
} from '../../app-routing-roots';
import {DL_ALERTS_LIST, DL_APPOINTMENTS_LIST, DL_CONTACT, DL_DASHBOARD, DL_ORDERS_LIST} from '../../delivery/delivery-routing-roots';
import {CCSPO_APPOINTMENTS_LIST, CCSPO_CONTACTS_LIST, CCSPO_CONTRACTS_LIST, CCSPO_DASHBOARD} from '@cc-sp-operator/cc-sp-routing-roots';
import {CCDKO_APPOINTMENTS_LIST, CCDKO_CONTRACTS_LIST, CCDKO_DASHBOARD} from '@cc-dekra-operator/cc-dk-o-routing-roots';
import {CCALD_CONTRACTS_LIST, CCALD_DASHBOARD, CCALD_SETTINGS} from '@cc-ald-operator/cc-ald-o-routing-roots';
import {CCDKC_DASHBOARD, CCDKC_PLANNING, CCDKC_USER_MANAGEMENT,} from '@cc-dekra/cc-dk-routing-roots';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {LoginRequestService} from '@shared/service/login-request.service';
import {CLAIMS_ADMIN_DASHBOARD, CLAIMS_ADMIN_LIST,} from 'app/claims/claims-admin/claims-admin-routing-roots';
import {CCDKBO_CONTRACTS_LIST, CCDKBO_DASHBOARD} from '@cc-dekra-backoffice/cc-dk-bo-routing-roots';
import {CLAIMS_SUPERVISOR_DASHBOARD, CLAIMS_SUPERVISOR_LIST, CLAIMS_SUPERVISOR_REPAIR} from 'app/claims/claims-supervisor/claims-supervisor-routing-roots';
import {CLAIMS_LIST, CLAIMS_PRACTICE_LIST, CLAIMS_THEFT} from '../../claims/claims-commons/claims-commons-routing-roots';
import {CLAIMS_PRACTICE_CAR_LIST} from '../../claims/claims-practice-car/claims-practice-car-roots';
import {CLAIM_LIST} from '../../claims/claims-olsa/claims-olsa-routing-roots';

import {AUTHORITY_APPOINTMENTS_LIST, AUTHORITY_DOSSIER_WORKING_LIST, AUTHORITY_DASHBOARD, AUTHORITY_DOSSIER_LIST, AUTHORITY_DOSSIER_LIST_CHANNEL, AUTHORITY_GLASS_LIST, AUTHORITY_GLASS_LIST_CHANNEL, AUTHORITY_QUOTATIONS_LIST} from 'app/authority/authority-routing-roots';
import {INVOICING_DASHBOARD, INVOICING_INVOICES, INVOICING_TASKS} from 'app/invoicing/invoicing-routing-roots';
import {TYRES_OPC_CONTRACTS, TYRES_OPC_DASHBOARD, TYRES_OPC_MOVEMENT, TYRES_OPC_TYRES} from '../../tyres/opc/tyres-opc-routing-roots';
import {TYRES_OPA, TYRES_OPC, TYRES_OPF, TYRES_OPS} from '../../tyres/tyres-routing-roots';
import {TYRES_OPA_DASHBOARD, TYRES_OPA_MOVEMENT, TYRES_OPA_TYRES_WAREHOUSE_CONTRACTS} from '../../tyres/opa/tyres-opa-routing-roots';
import {TYRES_OPF_DASHBOARD, TYRES_OPF_MOVEMENT, TYRES_OPF_TYRES_WAREHOUSE_CONTRACTS} from '../../tyres/opf/tyres-opf-routing-roots';
import {TYRES_OPS_CONTRACT, TYRES_OPS_DASHBOARD, TYRES_OPS_MOVEMENT} from '../../tyres/ops/tyres-ops-routing-roots';
import {UC_APPOINTMENTS, UC_ARCHIVEDPROCEDURES, UC_DASHBOARD, UC_PROCEDURES,} from 'app/user-change/user-change-routing-roots';
import {NC_ALERTS, NC_BREAKING_NEWS, NC_DASHBOARD, NC_NOTIFICATIONS} from 'app/notification-center/notification-center-routing-roots';
import {LOGISTICS_OPAD, LOGISTICS_OPASR, LOGISTICS_OPC, LOGISTICS_OPL} from '../../logistics/logistics-routing-roots';
import {LOGISTICS_OPL_DASHBOARD, LOGISTICS_OPL_TRANSFER, LOGISTICS_OPL_TRANSFER_REQUEST} from '../../logistics/opl/logistics-opl-routing-roots';
import {NemoModuleKeys, UserPermissionsModel} from '@shared/models/user-permission.model';
import {AUTHORITY_DEALER_USER, AuthorityUsersPermissions, BookingsPermissions, CROSS_PERMISSION_BREAKING_NEWS_BACKOFFICE, FlottaPoolUserPermissions, MOBILITY_MYMOBILITY_PROFILE_USER, NEMO_MOBILITY_BOOKINGS, PROFILE_CONTRACT_CLOSING_ADMIN_KEY, PROFILE_CONTRACT_CLOSING_SUPER_ADMIN_KEY, PROFILE_LOGISTIC_ADMIN_KEY, SuperUserPermissions} from '../../permissions-variables';
import {
	ADMINISTRATION_CHANNELING,
	ADMINISTRATION_RULES
} from '../../administration/administration-rules/administration-rules-routing-roots';
import {ADMINISTRATION_CENTER_LIST, ADMINISTRATION_USER} from '../../administration/administration-user-management/administration-users-routing-roots';
import {
	LOGISTICS_OPAD_ASR_LIST,
	LOGISTICS_OPAD_CHANNEL,
	LOGISTICS_OPAD_CHANNEL_SEGMENTS,
	LOGISTICS_OPAD_PENALTIES,
	LOGISTICS_OPAD_REQUEST_LIST,
	LOGISTICS_OPAD_RULES,
	LOGISTICS_OPAD_SEGMENTS,
	LOGISTICS_OPAD_SETTINGS,
	LOGISTICS_OPAD_TRANSPORTER
} from '../../logistics/opad/logistics-opad-routing-roots';
import {LOGISTICS_OASR_CHECK_IN, LOGISTICS_OASR_DASHBOARD, LOGISTICS_OASR_VEHICLE_DELIVERED, LOGISTICS_OASR_VEHICLE_ENTRY, LOGISTICS_OASR_VEHICLE_EXIT, LOGISTICS_OASR_VEHICLE_STOCK} from '../../logistics/oasr/logistics-oasr-routing-roots';
import {LOGISTICS_OPC_TRANSFER} from '../../logistics/opc/logistics-opc-routing-roots';
import {FlottaPoolRoutingRoots} from 'app/flotta-pool/flotta-pool-routing-roots';
import {BookingsRoutingRoots} from 'app/bookings/bookings-routing-roots';
import {ADMINISTRATION_DASHBOARD} from '../../administration/administration-channeling/administration-channeling-routing-roots';
import { MOBILITY_DASHBOARD, MOBILITY_DOSSIER_WORKING_LIST } from '@app/mobility/mobility-roots';
import { DL_CARGOS, DL_CARGOS_LIST } from 'app/cargos/cargos-routing-roots';

export class HeaderUtilitesModel {
	static environmentStatic: AppConfigEnvironment;

	static getItemsMenuDelivery(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: ItemMenu[] = [];

		if (currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.CONTRACT_CLOSING) || currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.CONTRACT_CLOSING_)) {
			items.push(new ItemMenu({
				id: UserV3Model.DELIVERY_ITEM_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: ROOT_CHANGE_CENTER_DELIVERY,
				routerLink: '/' + ROOT_DELIVERY + '/' + FIND_CENTERS_DASHBOARD
			}));
		}

		items.push(new ItemMenu({
			id: UserV3Model.DELIVERY_ITEM_MENU_ID + '.' + DL_DASHBOARD,
			name: DL_DASHBOARD,
			routerLink: '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.DELIVERY_ITEM_MENU_ID + '.' + DL_ORDERS_LIST,
			name: DL_ORDERS_LIST,
			routerLink: '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD + '/' + DL_ORDERS_LIST
		}));

		items.push(new ItemMenu({
			id: UserV3Model.DELIVERY_ITEM_MENU_ID + '.' + DL_ALERTS_LIST,
			name: DL_ALERTS_LIST,
			routerLink: '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD + '/' + DL_ALERTS_LIST,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.DELIVERY_ITEM_MENU_ID + '.' + DL_APPOINTMENTS_LIST,
			name: DL_APPOINTMENTS_LIST,
			routerLink: '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD + '/' + DL_APPOINTMENTS_LIST,
			count: 0
		}));

		/*
		 * CO 8309 - Tolta pagina contatti
		 * Ci sono solo 2 contatti fissi e non è necessario creare una pagina dedicata
		 * tolta la pagina anche dal routing
		 * delivery-routing.module.ts e delivery-asr-routing.module.ts
		 */

		// items.push(new ItemMenu({
		// 	id: UserV3Model.DELIVERY_ITEM_MENU_ID + '.' + DL_CONTACT,
		// 	name: DL_CONTACT,
		// 	routerLink: '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD + '/' + DL_CONTACT
		// }));

		return items;
	}

	static getItemsASRMenuDelivery(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.DELIVERY_ASR_ITEM_MENU_ID + '.' + DL_DASHBOARD,
			name: DL_DASHBOARD,
			routerLink: '/' + ROOT_DELIVERY_ASR + '/' + DL_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.DELIVERY_ASR_ITEM_MENU_ID + '.' + DL_ORDERS_LIST,
			name: DL_ORDERS_LIST,
			routerLink: '/' + ROOT_DELIVERY_ASR + '/' + DL_DASHBOARD + '/' + DL_ORDERS_LIST
		}));

		/*
		 * CO 8309 - Tolta pagina contatti
		 * Ci sono solo 2 contatti fissi e non è necessario creare una pagina dedicata
		 * tolta la pagina anche dal routing
		 * delivery-routing.module.ts e delivery-asr-routing.module.ts
		 */

		// items.push(new ItemMenu({
		// 	id: UserV3Model.DELIVERY_ASR_ITEM_MENU_ID + '.' + DL_CONTACT,
		// 	name: DL_CONTACT,
		// 	routerLink: '/' + ROOT_DELIVERY_ASR + '/' + DL_DASHBOARD + '/' + DL_CONTACT
		// }));

		return items;
	}

	static getItemsMenuProfile(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.PROFILE_ITEM_MENU_ID + '.' + ROOT_PROFILE,
			name: ROOT_PROFILE,
			routerLink: '/' + ROOT_PROFILE
		}));

		items.push(new ItemMenu({
			id: UserV3Model.PROFILE_ITEM_MENU_ID + '.' + 1,
			name: 'academy',
			routerLink: HeaderUtilitesModel.environmentStatic.ENTRY_POINT_E_LEARNING
		}));
		return items;
	}

	static getItemsMenuCCServicePointOperator(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: ItemMenu[] = [];
		if (currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.CONTRACT_CLOSING) || currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.CONTRACT_CLOSING_)) {
			items.push(new ItemMenu({
				id: UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: CHANGE_CENTERS_DASHBOARD,
				routerLink: '/' + ROOT_CONTRACT_CLOSING_SP + '/' + FIND_CENTERS_DASHBOARD
			}));
		}
		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID + '.' + CCSPO_DASHBOARD,
			name: CCSPO_DASHBOARD,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID + '.' + CCSPO_CONTRACTS_LIST,
			name: CCSPO_CONTRACTS_LIST,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD + '/' + CCSPO_CONTRACTS_LIST
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID + '.' + CCSPO_APPOINTMENTS_LIST,
			name: CCSPO_APPOINTMENTS_LIST,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD + '/' + CCSPO_APPOINTMENTS_LIST,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_SP_OP_ITEM_MENU_ID + '.' + CCSPO_CONTACTS_LIST,
			name: CCSPO_CONTACTS_LIST,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD + '/' + CCSPO_CONTACTS_LIST
		}));

		return items;
	}

	static getItemsMenuCCDekraOperator(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID + '.' + CCDKO_DASHBOARD,
			name: CCDKO_DASHBOARD,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_DK_OP + '/' + CCDKO_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID + '.' + CCDKO_CONTRACTS_LIST,
			name: CCDKO_CONTRACTS_LIST,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_DK_OP + '/' + CCDKO_DASHBOARD + '/' + CCDKO_CONTRACTS_LIST
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_DK_OP_ITEM_MENU_ID + '.' + CCDKO_APPOINTMENTS_LIST,
			name: CCDKO_APPOINTMENTS_LIST,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_DK_OP + '/' + CCDKO_DASHBOARD + '/' + CCDKO_APPOINTMENTS_LIST,
			count: 0
		}));

		return items;
	}

	static getItemsMenuCCALDOperator(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID + '.' + CCALD_DASHBOARD,
			name: CCALD_DASHBOARD,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_ALD + '/' + CCALD_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID + '.' + CCALD_CONTRACTS_LIST,
			name: CCALD_CONTRACTS_LIST,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_ALD + '/' + CCALD_DASHBOARD + '/' + CCALD_CONTRACTS_LIST
		}));

		if (currentUserPermissions.hasProfile([PROFILE_CONTRACT_CLOSING_ADMIN_KEY, PROFILE_CONTRACT_CLOSING_SUPER_ADMIN_KEY])) {
			items.push(new ItemMenu({
				id: UserV3Model.CONTRACT_CLOSING_ALD_OP_ITEM_MENU_ID + '.' + CCALD_SETTINGS,
				name: CCALD_SETTINGS,
				routerLink: '/' + ROOT_CONTRACT_CLOSING_ALD + '/' + CCALD_DASHBOARD + '/' + CCALD_SETTINGS
			}));
		}


		return items;
	}

	static getItemsMenuCCBackOffice(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_DK_BO_OP_ITEM_MENU_ID + '.' + CCDKBO_DASHBOARD,
			name: CCDKBO_DASHBOARD,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_DK_BO + '/' + CCDKBO_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_DK_BO_OP_ITEM_MENU_ID + '.' + CCDKBO_CONTRACTS_LIST,
			name: CCDKBO_CONTRACTS_LIST,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_DK_BO + '/' + CCDKBO_DASHBOARD + '/' + CCDKBO_CONTRACTS_LIST
		}));

		return items;
	}

	static getItemsMenuCCDekraCenter(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_DK_C_ITEM_MENU_ID + '.' + CCDKC_DASHBOARD,
			name: CCDKC_DASHBOARD,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_DK_C + '/' + CCALD_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_DK_C_ITEM_MENU_ID + '.' + CCDKC_USER_MANAGEMENT,
			name: CCDKC_USER_MANAGEMENT,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_DK_C + '/' + CCDKC_DASHBOARD + '/' + CCDKC_USER_MANAGEMENT,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CONTRACT_CLOSING_DK_C_ITEM_MENU_ID + '.' + CCDKC_PLANNING,
			name: CCDKC_PLANNING,
			routerLink: '/' + ROOT_CONTRACT_CLOSING_DK_C + '/' + CCDKC_DASHBOARD + '/' + CCDKC_PLANNING,
			count: 0
		}));

		return items;
	}

	static getItemsMenuClaimsAdmin(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID + '.' + CLAIMS_ADMIN_DASHBOARD,
			name: CLAIMS_ADMIN_DASHBOARD,
			routerLink: '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_ADMIN_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID + '.' + CLAIMS_ADMIN_LIST,
			name: CLAIMS_ADMIN_LIST,
			routerLink: '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_ADMIN_DASHBOARD + '/' + CLAIMS_ADMIN_LIST
		}));

		/*
		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID + '.' + CLAIMS_THEFT,
			name: CLAIMS_THEFT,
			routerLink: '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_THEFT
		}));
		*/

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID + '.' + CLAIMS_PRACTICE_LIST,
			name: CLAIMS_PRACTICE_LIST,
			routerLink: '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_PRACTICE_LIST
		}));

		/*
		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID + '.' + CLAIMS_REPAIR,
			name: CLAIMS_REPAIR,
			routerLink: '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_REPAIR

		}));
		*/
		
		return items;
	}
	static getItemsMenuClaimsCustomAdmin(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID + '.' + CLAIMS_ADMIN_DASHBOARD,
			name: CLAIMS_ADMIN_DASHBOARD,
			routerLink: '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_ADMIN_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_ADMIN_ITEM_MENU_ID + '.' + CLAIMS_ADMIN_LIST,
			name: CLAIMS_ADMIN_LIST,
			routerLink: '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_ADMIN_DASHBOARD + '/' + CLAIMS_ADMIN_LIST
		}));
		return items;
	}

	static getItemsMenuClaimsRepair(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_REPAIR_ITEM_MENU_ID + '.' + CLAIMS_REPAIR,
			name: CLAIMS_REPAIR,
			routerLink: '/' + ROOT_CLAIMS_REPAIR + '/' + CLAIMS_LIST

		}));

		return items;
	}

	static getItemsMenuClaimsTheft(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_THEFT_ITEM_MENU_ID + '.' + CLAIMS_THEFT,
			name: CLAIMS_THEFT,
			routerLink: '/' + ROOT_CLAIMS_THEFT + '/' + CLAIMS_LIST
		}));
		return items;
	}

	static getItemsMenuClaimsSupervisor(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_SUPERVISOR_ITEM_MENU_ID + '.' + CLAIMS_SUPERVISOR_DASHBOARD,
			name: CLAIMS_SUPERVISOR_DASHBOARD,
			routerLink: '/' + ROOT_CLAIMS_SUPERVISOR + '/' + CLAIMS_SUPERVISOR_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_SUPERVISOR_ITEM_MENU_ID + '.' + CLAIMS_SUPERVISOR_LIST,
			name: CLAIMS_SUPERVISOR_LIST,
			routerLink: '/' + ROOT_CLAIMS_SUPERVISOR + '/' + CLAIMS_SUPERVISOR_DASHBOARD + '/' + CLAIMS_SUPERVISOR_LIST
		}));

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_SUPERVISOR_ITEM_MENU_ID + '.' + CLAIMS_SUPERVISOR_REPAIR,
			name: CLAIMS_SUPERVISOR_REPAIR,
			routerLink: '/' + ROOT_CLAIMS_SUPERVISOR + '/' + CLAIMS_SUPERVISOR_DASHBOARD + '/' + CLAIMS_SUPERVISOR_REPAIR
		}));

		return items;
	}

	static getItemsMenuClaimsOlsa(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_OLSA_ITEM_MENU_ID + '.' + CLAIM_LIST,
			name: CLAIM_LIST,
			routerLink: '/' + ROOT_CLAIMS_OLSA + '/' + CLAIM_LIST
		}));

		return items;
	}

	static getItemsMenuClaimsPracticeCar(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_PRACTICE_CAR_ITEM_MENU_ID + '.' + CLAIMS_PRACTICE_CAR_LIST,
			name: CLAIMS_PRACTICE_CAR_LIST,
			routerLink: '/' + ROOT_CLAIMS_PRACTICE_CAR + '/' + CLAIMS_PRACTICE_CAR_LIST
		}));

		return items;
	}

	static getItemsMenuClaimsPractices(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_PRACTICES_ITEM_MENU_ID + '.' + CLAIMS_PRACTICE_LIST,
			name: CLAIMS_PRACTICE_LIST,
			routerLink: '/' + ROOT_CLAIMS_PRACTICES + '/' + CLAIMS_PRACTICE_LIST
		}));

		return items;
	}

	static getItemsMenuClaimsComplaint(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.CLAIMS_COMPLAINT_ITEM_MENU_ID + '.' + CLAIMS_LIST,
			name: CLAIM_LIST,
			routerLink: '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST
		}));
		return items;
	}

	static getItemsMenuMobility(user: UserPermissionsModel): ItemMenu[] {

		if (user.hasCurrentProfile(MOBILITY_MYMOBILITY_PROFILE_USER)) {
			return [
				new ItemMenu({
					id: UserV3Model.MOBILITY_ITEM_MENU_ID + '.' + MOBILITY_DASHBOARD,
					name: MOBILITY_DASHBOARD,
					routerLink: '/' + ROOT_MOBILITY + '/' + MOBILITY_DASHBOARD
				}),
				new ItemMenu({
					id: UserV3Model.MOBILITY_ITEM_MENU_ID + '.' + MOBILITY_DOSSIER_WORKING_LIST,
					name: MOBILITY_DOSSIER_WORKING_LIST,
					routerLink: '/' + ROOT_MOBILITY + '/' + MOBILITY_DASHBOARD + '/' + MOBILITY_DOSSIER_WORKING_LIST,
					count: 0
				})
			];
		}
	}

	static getItemsMenuAuthority(user: UserPermissionsModel): ItemMenu[] {

		const permissions = AuthorityUsersPermissions;
		const isCenterOperator = user.isCenterOperator(NemoModuleKeys.AUTHORITY);
		const isDealerOperator = user.isDealerOperator2();

		const grantsMap = {
			// Cambia Centro
			[CHANGE_CENTERS_DASHBOARD]: (
				user.hasPermissions(SuperUserPermissions.super_user_can_read_all) && 
				user.isCenterSuperUserOperator(NemoModuleKeys.AUTHORITY)
			),
			// dashboard
			[AUTHORITY_DASHBOARD]: (
				user.hasSomePermission([
					permissions.authority_dashboard,
					permissions.authority_dealer_dashboard,
					permissions.authority_admin_dashboard,
					permissions.authority_supervisor_dashboard,
					permissions.authority_administrative_practice_dashboard,
					permissions.authority_merged_dashboard,
					SuperUserPermissions.super_user_can_read_all
				])
			),
			// dossier-workings
			[AUTHORITY_DOSSIER_WORKING_LIST]: (
				user.hasPermissions(permissions.authority_workings_read)
			),
			// dossiers
			[AUTHORITY_DOSSIER_LIST]: (
				user.hasPermissions(permissions.authority_dossiers_read) 
			),
			// channel-filtered
			[AUTHORITY_DOSSIER_LIST_CHANNEL]: (
				user.hasPermissions(permissions.supervisor_channeling) && 
				!isCenterOperator
			),
			// appointments
			[AUTHORITY_APPOINTMENTS_LIST]: (
				user.hasPermissions(permissions.authority_appointments_list)
			),
			// glass
			[AUTHORITY_GLASS_LIST]: (
				user.hasPermissions(permissions.carglass_read) && 
				!isCenterOperator
			),
			// channel-glass
			[AUTHORITY_GLASS_LIST_CHANNEL]: (
				user.hasPermissions(permissions.supervisor_channeling) && 
				!isCenterOperator
			),
			// operations
			[AUTHORITY_QUOTATIONS_LIST]: (
				user.hasPermissions(permissions.authority_orders_read) &&
				// fix temporanea
				// questo forza la voce del menù per il DEALER
				// andrebbe fixata la regressione causata in isCenterOperator
				// con l'aggiunta errata del DEALER nel controllo
				(isDealerOperator)
			),
		};

		const items: ItemMenu[] = [];
		if (grantsMap[CHANGE_CENTERS_DASHBOARD]) {
			items.push(new ItemMenu({
				id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: CHANGE_CENTERS_DASHBOARD,
				routerLink: '/' + ROOT_AUTHORITY + '/' + FIND_CENTERS_DASHBOARD,

			}));
		}
		if (grantsMap[AUTHORITY_DASHBOARD]) {
			items.push(new ItemMenu({
				id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + AUTHORITY_DASHBOARD,
				name: AUTHORITY_DASHBOARD,
				routerLink: '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD
			}));
		}
		if (grantsMap[AUTHORITY_DOSSIER_WORKING_LIST]) {
			items.push(new ItemMenu({
				id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + AUTHORITY_DOSSIER_WORKING_LIST,
				name: AUTHORITY_DOSSIER_WORKING_LIST,
				routerLink: '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_DOSSIER_WORKING_LIST,
				count: 0
			}));
		}
		if (grantsMap[AUTHORITY_DOSSIER_LIST]) {
			items.push(new ItemMenu({
				id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + AUTHORITY_DOSSIER_LIST,
				name: AUTHORITY_DOSSIER_LIST,
				routerLink: '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_DOSSIER_LIST
			}));
		}
		if (grantsMap[AUTHORITY_DOSSIER_LIST_CHANNEL]) {
			items.push(new ItemMenu({
				id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + AUTHORITY_DOSSIER_LIST_CHANNEL,
				name: AUTHORITY_DOSSIER_LIST_CHANNEL,
				routerLink: '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_DOSSIER_LIST_CHANNEL
			}));
		}
		if (grantsMap[AUTHORITY_APPOINTMENTS_LIST]) { 
			items.push(new ItemMenu({
				id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + AUTHORITY_APPOINTMENTS_LIST,
				name: AUTHORITY_APPOINTMENTS_LIST,
				routerLink: '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_APPOINTMENTS_LIST,
				count: 0
			}));
		}
		if (grantsMap[AUTHORITY_GLASS_LIST]) {
			items.push(new ItemMenu({
				id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + AUTHORITY_GLASS_LIST,
				name: AUTHORITY_GLASS_LIST,
				routerLink: '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_GLASS_LIST
			}));
			if (grantsMap[AUTHORITY_GLASS_LIST_CHANNEL]) {
				items.push(new ItemMenu({
					id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + AUTHORITY_GLASS_LIST_CHANNEL,
					name: AUTHORITY_GLASS_LIST_CHANNEL,
					routerLink: '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_GLASS_LIST_CHANNEL
				}));
			}
		}
		if (grantsMap[AUTHORITY_QUOTATIONS_LIST]) {
			items.push(new ItemMenu({
				id: UserV3Model.AUTHORITY_ITEM_MENU_ID + '.' + AUTHORITY_QUOTATIONS_LIST,
				name: AUTHORITY_QUOTATIONS_LIST,
				routerLink: '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_QUOTATIONS_LIST
			}));
		}
		return items;
	}

	static getItemsMenuInvoicing(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: ItemMenu[] = [];
		if (currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.INVOICING)) {
			items.push(new ItemMenu({
				id: UserV3Model.INVOICING_ITEM_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: CHANGE_CENTERS_DASHBOARD,
				routerLink: '/' + ROOT_INVOICING + '/' + FIND_CENTERS_DASHBOARD
			}));
		}
		items.push(new ItemMenu({
			id: UserV3Model.INVOICING_ITEM_MENU_ID + '.' + INVOICING_DASHBOARD,
			name: INVOICING_DASHBOARD,
			routerLink: '/' + ROOT_INVOICING + '/' + INVOICING_DASHBOARD
		}));
		items.push(new ItemMenu({
			id: UserV3Model.INVOICING_ITEM_MENU_ID + '.' + INVOICING_TASKS,
			name: INVOICING_TASKS,
			routerLink: '/' + ROOT_INVOICING + '/' + INVOICING_TASKS
		}));
		items.push(new ItemMenu({
			id: UserV3Model.INVOICING_ITEM_MENU_ID + '.' + INVOICING_INVOICES,
			name: INVOICING_INVOICES,
			routerLink: '/' + ROOT_INVOICING + '/' + INVOICING_INVOICES
		}));

		return items;
	}

	static getItemsMenuTyresOpc(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: ItemMenu[] = [];
		if (currentUserPermissions.hasSomePermission([
			SuperUserPermissions.super_user_can_read_all
		]) && currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.TYRES)) {
			items.push(new ItemMenu({
				id: UserV3Model.TYRES_ITEM_OPC_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: CHANGE_CENTERS_DASHBOARD,
				routerLink: `/${ROOT_TYRES}/${TYRES_OPC}/${FIND_CENTERS_DASHBOARD}`,
				count: 0
			}));
		}

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPC_MENU_ID + '.' + TYRES_OPC_DASHBOARD,
			name: TYRES_OPC_DASHBOARD,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPC}/${TYRES_OPC_DASHBOARD}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPC_MENU_ID + '.' + TYRES_OPC_DASHBOARD + '.' + TYRES_OPC_TYRES,
			name: TYRES_OPC_TYRES,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPC}/${TYRES_OPC_DASHBOARD}/${TYRES_OPC_TYRES}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPC_MENU_ID + '.' + TYRES_OPC_DASHBOARD + '.' + TYRES_OPC_CONTRACTS,
			name: TYRES_OPC_CONTRACTS,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPC}/${TYRES_OPC_DASHBOARD}/${TYRES_OPC_CONTRACTS}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPC_MENU_ID + '.' + TYRES_OPC_DASHBOARD + '.' + TYRES_OPC_MOVEMENT,
			name: TYRES_OPC_MOVEMENT,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPC}/${TYRES_OPC_DASHBOARD}/${TYRES_OPC_MOVEMENT}`,
			count: 0
		}));

		return items;
	}

	static getItemsMenuTyresOpa(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPA_MENU_ID + '.' + TYRES_OPA_DASHBOARD,
			name: TYRES_OPA_DASHBOARD,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPA}/${TYRES_OPA_DASHBOARD}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPA_MENU_ID + '.' + TYRES_OPA_DASHBOARD + '.' + TYRES_OPA_TYRES_WAREHOUSE_CONTRACTS,
			name: TYRES_OPA_TYRES_WAREHOUSE_CONTRACTS,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPA}/${TYRES_OPA_DASHBOARD}/${TYRES_OPA_TYRES_WAREHOUSE_CONTRACTS}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPA_MENU_ID + '.' + TYRES_OPA_DASHBOARD + '.' + TYRES_OPA_MOVEMENT,
			name: TYRES_OPA_MOVEMENT,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPA}/${TYRES_OPA_DASHBOARD}/${TYRES_OPA_MOVEMENT}`,
			count: 0
		}));

		return items;
	}

	static getItemsMenuTyresOps(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPS_MENU_ID + '.' + TYRES_OPS_DASHBOARD,
			name: TYRES_OPS_DASHBOARD,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPS}/${TYRES_OPS_DASHBOARD}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPS_MENU_ID + '.' + TYRES_OPS_DASHBOARD + '.' + TYRES_OPS_CONTRACT,
			name: TYRES_OPS_CONTRACT,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPS}/${TYRES_OPS_DASHBOARD}/${TYRES_OPS_CONTRACT}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPS_MENU_ID + '.' + TYRES_OPS_DASHBOARD + '.' + TYRES_OPS_MOVEMENT,
			name: TYRES_OPS_MOVEMENT,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPS}/${TYRES_OPS_DASHBOARD}/${TYRES_OPS_MOVEMENT}`,
			count: 0
		}));

		return items;
	}

	static getItemsMenuLogisticsOpl(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPL_MENU_ID + '.' + LOGISTICS_OPL_DASHBOARD,
			name: LOGISTICS_OPL_DASHBOARD,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPL}/${LOGISTICS_OPL_DASHBOARD}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPL_MENU_ID + '.' + LOGISTICS_OPL_DASHBOARD + '.' + LOGISTICS_OPL_TRANSFER,
			name: LOGISTICS_OPL_TRANSFER,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPL}/${LOGISTICS_OPL_DASHBOARD}/${LOGISTICS_OPL_TRANSFER}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPL_MENU_ID + '.' + LOGISTICS_OPL_DASHBOARD + '.' + LOGISTICS_OPL_TRANSFER_REQUEST,
			name: LOGISTICS_OPL_TRANSFER_REQUEST,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPL}/${LOGISTICS_OPL_DASHBOARD}/${LOGISTICS_OPL_TRANSFER_REQUEST}`,
			count: 0
		}));

		return items;
	}

	static getItemsMenuLogisticsOpasr(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: ItemMenu[] = [];
		if (currentUserPermissions.hasSomePermission([
			SuperUserPermissions.super_user_can_read_all
		]) && currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.LOGISTICS)) {
			items.push(new ItemMenu({
				id: UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: CHANGE_CENTERS_DASHBOARD,
				routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPASR}/${FIND_CENTERS_DASHBOARD}`,
				count: 0
			}));
		}
		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID + '.' + LOGISTICS_OASR_DASHBOARD,
			name: LOGISTICS_OASR_DASHBOARD,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPASR}/${LOGISTICS_OASR_DASHBOARD}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID + '.' + LOGISTICS_OASR_DASHBOARD + '.' + LOGISTICS_OASR_VEHICLE_ENTRY,
			name: LOGISTICS_OASR_VEHICLE_ENTRY,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPASR}/${LOGISTICS_OASR_DASHBOARD}/${LOGISTICS_OASR_VEHICLE_ENTRY}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID + '.' + LOGISTICS_OASR_DASHBOARD + '.' + LOGISTICS_OASR_VEHICLE_EXIT,
			name: LOGISTICS_OASR_VEHICLE_EXIT,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPASR}/${LOGISTICS_OASR_DASHBOARD}/${LOGISTICS_OASR_VEHICLE_EXIT}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID + '.' + LOGISTICS_OASR_DASHBOARD + '.' + LOGISTICS_OASR_VEHICLE_STOCK,
			name: LOGISTICS_OASR_VEHICLE_STOCK,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPASR}/${LOGISTICS_OASR_DASHBOARD}/${LOGISTICS_OASR_VEHICLE_STOCK}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID + '.' + LOGISTICS_OASR_DASHBOARD + '.' + LOGISTICS_OASR_VEHICLE_DELIVERED,
			name: LOGISTICS_OASR_VEHICLE_DELIVERED,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPASR}/${LOGISTICS_OASR_DASHBOARD}/${LOGISTICS_OASR_VEHICLE_DELIVERED}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPASR_MENU_ID + '.' + LOGISTICS_OASR_DASHBOARD + '.' + LOGISTICS_OASR_CHECK_IN,
			name: LOGISTICS_OASR_CHECK_IN,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPASR}/${LOGISTICS_OASR_DASHBOARD}/${LOGISTICS_OASR_CHECK_IN}`,
			count: 0
		}));

		return items;
	}

	static getItemsMenuLogisticsOpad(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_RULES,
			name: LOGISTICS_OPAD_RULES,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_RULES}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_TRANSPORTER,
			name: LOGISTICS_OPAD_TRANSPORTER,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_TRANSPORTER}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_PENALTIES,
			name: LOGISTICS_OPAD_PENALTIES,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_PENALTIES}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_CHANNEL,
			name: LOGISTICS_OPAD_CHANNEL,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_CHANNEL}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_SEGMENTS,
			name: LOGISTICS_OPAD_SEGMENTS,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_SEGMENTS}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_CHANNEL_SEGMENTS,
			name: LOGISTICS_OPAD_CHANNEL_SEGMENTS,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_CHANNEL_SEGMENTS}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_ASR_LIST,
			name: LOGISTICS_OPAD_ASR_LIST,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_ASR_LIST}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_REQUEST_LIST,
			name: LOGISTICS_OPAD_REQUEST_LIST,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_REQUEST_LIST}`,
			count: 0
		}));

		if (currentUserPermissions.hasProfile([PROFILE_LOGISTIC_ADMIN_KEY])) {
			items.push(new ItemMenu({
				id: UserV3Model.LOGISTICS_ITEM_OPAD_MENU_ID + '.' + LOGISTICS_OPAD_SETTINGS,
				name: LOGISTICS_OPAD_SETTINGS,
				routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPAD}/${LOGISTICS_OPAD_SETTINGS}`,
				count: 0
			}));
		}

		return items;
	}

	static getItemsMenuLogisticsOpc(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.LOGISTICS_ITEM_OPC_MENU_ID + '.' + LOGISTICS_OPC,
			name: LOGISTICS_OPC_TRANSFER,
			routerLink: `/${ROOT_LOGISTICS}/${LOGISTICS_OPC}/${LOGISTICS_OPC_TRANSFER}`,
			count: 0
		}));

		return items;
	}

	static getItemsMenuTyresOpf(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPF_MENU_ID + '.' + TYRES_OPF_DASHBOARD,
			name: TYRES_OPF_DASHBOARD,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPF}/${TYRES_OPF_DASHBOARD}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPF_MENU_ID + '.' + TYRES_OPF_DASHBOARD + '.' + TYRES_OPF_TYRES_WAREHOUSE_CONTRACTS,
			name: TYRES_OPF_TYRES_WAREHOUSE_CONTRACTS,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPF}/${TYRES_OPF_DASHBOARD}/${TYRES_OPF_TYRES_WAREHOUSE_CONTRACTS}`,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.TYRES_ITEM_OPF_MENU_ID + '.' + TYRES_OPF_DASHBOARD + '.' + TYRES_OPF_MOVEMENT,
			name: TYRES_OPF_MOVEMENT,
			routerLink: `/${ROOT_TYRES}/${TYRES_OPF}/${TYRES_OPF_DASHBOARD}/${TYRES_OPF_MOVEMENT}`,
			count: 0
		}));

		return items;
	}

	static getItemsMenuUCAld(): ItemMenu[] {
		const items: ItemMenu[] = [];

		items.push(new ItemMenu({
			id: UserV3Model.USER_CHANGE_ALD_MENU_ID + '.' + UC_DASHBOARD,
			name: UC_DASHBOARD,
			routerLink: '/' + ROOT_USER_CHANGE_ALD + '/' + UC_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.USER_CHANGE_ALD_MENU_ID + '.' + UC_PROCEDURES,
			name: UC_PROCEDURES,
			routerLink: '/' + ROOT_USER_CHANGE_ALD + '/' + UC_DASHBOARD + '/' + UC_PROCEDURES,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.USER_CHANGE_ALD_MENU_ID + '.' + UC_ARCHIVEDPROCEDURES,
			name: UC_ARCHIVEDPROCEDURES,
			routerLink: '/' + ROOT_USER_CHANGE_ALD + '/' + UC_DASHBOARD + '/' + UC_ARCHIVEDPROCEDURES,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.USER_CHANGE_ALD_MENU_ID + '.' + UC_APPOINTMENTS,
			name: UC_APPOINTMENTS,
			routerLink: '/' + ROOT_USER_CHANGE_ALD + '/' + UC_DASHBOARD + '/' + UC_APPOINTMENTS,
			count: 0
		}));

		return items;
	}

	static getItemsMenuUCSp(currentUserPermissions: any): ItemMenu[] {
		const items: ItemMenu[] = [];
		if (currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.USER_CHNAGE_)) {
			items.push(new ItemMenu({
				id: UserV3Model.USER_CHANGE_SP_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: CHANGE_CENTERS_DASHBOARD,
				routerLink: '/' + ROOT_USER_CHANGE_SP + '/' + FIND_CENTERS_DASHBOARD
			}));
		}

		items.push(new ItemMenu({
			id: UserV3Model.USER_CHANGE_SP_MENU_ID + '.' + UC_DASHBOARD,
			name: UC_DASHBOARD,
			routerLink: '/' + ROOT_USER_CHANGE_SP + '/' + UC_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.USER_CHANGE_SP_MENU_ID + '.' + UC_PROCEDURES,
			name: UC_PROCEDURES,
			routerLink: '/' + ROOT_USER_CHANGE_SP + '/' + UC_DASHBOARD + '/' + UC_PROCEDURES,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.USER_CHANGE_SP_MENU_ID + '.' + UC_ARCHIVEDPROCEDURES,
			name: UC_ARCHIVEDPROCEDURES,
			routerLink: '/' + ROOT_USER_CHANGE_SP + '/' + UC_DASHBOARD + '/' + UC_ARCHIVEDPROCEDURES,
			count: 0
		}));

		items.push(new ItemMenu({
			id: UserV3Model.USER_CHANGE_SP_MENU_ID + '.' + UC_APPOINTMENTS,
			name: UC_APPOINTMENTS,
			routerLink: '/' + ROOT_USER_CHANGE_SP + '/' + UC_DASHBOARD + '/' + UC_APPOINTMENTS,
			count: 0
		}));

		return items;
	}

	static getItemsMenuNotification(currentUserPermission: UserPermissionsModel): ItemMenu[] {
		const items: ItemMenu[] = [];

		if (currentUserPermission.isSuperUserByLocationPath(ROOT_NOTIFICATION_CENTER)) {
			items.push(new ItemMenu({
				id: UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: CHANGE_CENTERS_DASHBOARD,
				routerLink: `/${ROOT_NOTIFICATION_CENTER}/${FIND_CENTERS_DASHBOARD}`
			}));

		}

		items.push(new ItemMenu({
			id: UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID + '.' + NC_DASHBOARD,
			name: NC_DASHBOARD,
			routerLink: `/${ROOT_NOTIFICATION_CENTER}/${NC_DASHBOARD}`
		}));

		items.push(new ItemMenu({
			id: UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID + '.' + NC_ALERTS,
			name: NC_ALERTS,
			routerLink: `/${ROOT_NOTIFICATION_CENTER}/${NC_DASHBOARD}/${NC_ALERTS}`
		}));

		items.push(new ItemMenu({
			id: UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID + '.' + NC_NOTIFICATIONS,
			name: NC_NOTIFICATIONS,
			routerLink: `/${ROOT_NOTIFICATION_CENTER}/${NC_DASHBOARD}/${NC_NOTIFICATIONS}`
		}));

		if (currentUserPermission.hasCrossPermission(CROSS_PERMISSION_BREAKING_NEWS_BACKOFFICE)) {
			items.push(new ItemMenu({
				id: UserV3Model.NOTIFICATION_CENTER_ITEM_MENU_ID + '.' + NC_BREAKING_NEWS,
				name: NC_BREAKING_NEWS,
				routerLink: `/${ROOT_NOTIFICATION_CENTER}/${NC_DASHBOARD}/${NC_BREAKING_NEWS}`
			}));

		}

		return items;
	}

	static getItemsMenuAdministrationRules(): ItemMenu[] {
		const items: ItemMenu[] = [];
		/*
		items.push(new ItemMenu({
			id: UserV3Model.ADMINISTRATION_RULES_MENU_ID + '.' + ADMINISTRATION_DASHBOARD,
			name: ADMINISTRATION_DASHBOARD,
			routerLink: '/' + ROOT_ADMINISTRATION_RULES + '/' + ADMINISTRATION_DASHBOARD
		}));
		*/
		items.push(new ItemMenu({
			id: UserV3Model.ADMINISTRATION_RULES_MENU_ID + '.' + ADMINISTRATION_RULES,
			name: ADMINISTRATION_RULES,
			routerLink: '/' + ROOT_ADMINISTRATION_RULES + '/' + ADMINISTRATION_RULES
		}));

		return items;
	}

	static getItemsMenuAdministrationUsersM(): ItemMenu[] {
		const items: ItemMenu[] = [];
		// items.push(new ItemMenu({
		// 	id: UserV3Model.ADMINISTRATION_USERS_MENU_ID + '.' + ADMINISTRATION_USER_DASHBOARD,
		// 	name: ADMINISTRATION_USER_DASHBOARD,
		// 	routerLink: '/' + ROOT_ADMINISTRATION_USER_MANAGEMENT + '/' + ADMINISTRATION_USER_DASHBOARD,
		// }));
		items.push(new ItemMenu({
			id: UserV3Model.ADMINISTRATION_USERS_MENU_ID + '.' + ADMINISTRATION_USER,
			name: ADMINISTRATION_USER,
			routerLink: '/' + ROOT_ADMINISTRATION_USER_MANAGEMENT + '/' + ADMINISTRATION_USER,
		}));
		items.push(new ItemMenu({
			id: UserV3Model.ADMINISTRATION_USERS_MENU_ID + '.' + ADMINISTRATION_CENTER_LIST,
			name: ADMINISTRATION_CENTER_LIST,
			routerLink: '/' + ROOT_ADMINISTRATION_USER_MANAGEMENT + '/' + ADMINISTRATION_CENTER_LIST,
		}));
		return items;
	}

	static getItemsMenuAdministrationChanneling(): ItemMenu[] {
		const items: ItemMenu[] = [];
		items.push(new ItemMenu({
			id: UserV3Model.ADMINISTRATION_CHANNELING_MENU_ID + '.' + ADMINISTRATION_DASHBOARD,
			name: ADMINISTRATION_DASHBOARD,
			routerLink: '/' + ROOT_ADMINISTRATION_CHANNELING + '/' + ADMINISTRATION_DASHBOARD
		}));

		items.push(new ItemMenu({
			id: UserV3Model.ADMINISTRATION_CHANNELING_MENU_ID + '.' + ADMINISTRATION_CHANNELING,
			name: ADMINISTRATION_CHANNELING,
			routerLink: '/' + ROOT_ADMINISTRATION_CHANNELING + '/' + ADMINISTRATION_DASHBOARD + '/' + ADMINISTRATION_CHANNELING
		}));
		return items;
	}

	static getItemsMenuFlottaPool(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: any = [];
		if (currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL)) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FIND_CENTERS_DASHBOARD,
				name: CHANGE_CENTERS_DASHBOARD,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FIND_CENTERS_DASHBOARD
			}));
		}

		if (
			currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_view_dashboard) &&
			!currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL)
		) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.DASHBOARD,
				name: FlottaPoolRoutingRoots.DASHBOARD,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD
			}));
		}

		if (
			currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_view_insert) &&
			!currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL)
		) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.INSERT,
				name: FlottaPoolRoutingRoots.INSERT,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD + '/' + FlottaPoolRoutingRoots.INSERT
			}));
		}

		if (currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_view_transfer)) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.TRANSFER,
				name: FlottaPoolRoutingRoots.TRANSFER,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD + '/' + FlottaPoolRoutingRoots.TRANSFER
			}));
		}

		if (currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_view_vehicles_fleet)) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.VEHICLES,
				name: FlottaPoolRoutingRoots.VEHICLES,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD + '/' + FlottaPoolRoutingRoots.VEHICLES
			}));
		}
		if (
			currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_view_cluster) &&
			!currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL)
		) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.CLUSTER,
				name: FlottaPoolRoutingRoots.CLUSTER,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD + '/' + FlottaPoolRoutingRoots.CLUSTER
			}));
		}

		if (
			currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_view_help_center) &&
			!currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL)
		) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.INVENTORY_LIST_HELP_CENTER,
				name: FlottaPoolRoutingRoots.INVENTORY_LIST_HELP_CENTER,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD + '/' + FlottaPoolRoutingRoots.INVENTORY_LIST_HELP_CENTER
			}));
		}
		
		if (
			currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_view_history) &&
			!currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL)
		) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.HISTORY,
				name: FlottaPoolRoutingRoots.HISTORY,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD + '/' + FlottaPoolRoutingRoots.HISTORY
			}));
		}

		if (
			currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_view_settings) &&
			!currentUserPermissions.isCenterSuperUserOperator(NemoModuleKeys.FLOTTA_POOL)
		) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.SETTINGS,
				name: FlottaPoolRoutingRoots.SETTINGS,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.SETTINGS
			}));
		}

		if (currentUserPermissions.hasPermissions(FlottaPoolUserPermissions.flotta_pool_user_can_send_inventory_vehicles_inventory)) {
			items.push(new ItemMenu({
				id: UserV3Model.FLOTTA_POOL_MENU_ID + '.' + FlottaPoolRoutingRoots.INVENTORY,
				name: FlottaPoolRoutingRoots.INVENTORY,
				routerLink: '/' + ROOT_FLOTTA_POOL + '/' + FlottaPoolRoutingRoots.DASHBOARD + '/' + FlottaPoolRoutingRoots.INVENTORY
			}));
		}

		return items;
	}

	static getItemsMenuBookingsRelief(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: any = [];
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_relief_can_view_dashboard)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_RELIEF_MENU_ID + '.' + BookingsRoutingRoots.DASHBOARD,
				name: BookingsRoutingRoots.DASHBOARD,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.RELIEF + '/' + BookingsRoutingRoots.DASHBOARD
			}));
		}
		if (currentUserPermissions.hasPermissions([BookingsPermissions.bookings_relief_can_retrieve_customer_vip_list, BookingsPermissions.bookings_relief_can_retrieve_plate_vip_list])) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_RELIEF_MENU_ID + '.' + BookingsRoutingRoots.ANAGRAFICHE,
				name: BookingsRoutingRoots.PERSONAL_DATA,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.RELIEF + '/' + BookingsRoutingRoots.ANAGRAFICHE
			}));
		}
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_relief_can_retrieve_aci_list)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_RELIEF_MENU_ID + '.' + BookingsRoutingRoots.ACI,
				name: BookingsRoutingRoots.ACI,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.RELIEF + '/' + BookingsRoutingRoots.ACI
			}));
		}
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_relief_can_retrieve_rac_list)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_RELIEF_MENU_ID + '.' + BookingsRoutingRoots.RAC,
				name: BookingsRoutingRoots.RAC,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.RELIEF + '/' + BookingsRoutingRoots.RAC
			}));
		}
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_relief_can_retrieve_history_list)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_RELIEF_MENU_ID + '.' + BookingsRoutingRoots.BOOKING_HISTORY,
				name: BookingsRoutingRoots.BOOKING_HISTORY,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.RELIEF + '/' + BookingsRoutingRoots.BOOKING_HISTORY
			}));
		}
		items.push(new ItemMenu({ // wave 1
			id: UserV3Model.BOOKINGS_RELIEF_MENU_ID + '.' + BookingsRoutingRoots.RESERVATION_LIST,
			name: BookingsRoutingRoots.RESERVATION_LIST,
			routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.RELIEF + '/' + BookingsRoutingRoots.RESERVATION_LIST
		}));
		if (currentUserPermissions.hasProfile(NEMO_MOBILITY_BOOKINGS)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_RELIEF_MENU_ID + '.' + BookingsRoutingRoots.MOBILITY_RESERVATION_LIST,
				name: BookingsRoutingRoots.MOBILITY_RESERVATION_LIST,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.RELIEF + '/' + BookingsRoutingRoots.MOBILITY_RESERVATION_LIST
			}));
		}
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_relief_can_retrieve_settings)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_RELIEF_MENU_ID + '.' + BookingsRoutingRoots.SETTINGS,
				name: BookingsRoutingRoots.SETTINGS,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.RELIEF + '/' + BookingsRoutingRoots.SETTINGS
			}));
		}

		return items;
	}

	static getItemsMenuBookingsPrelease(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: any = [];
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_prelease_can_view_dashboard)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_PRELEASE_MENU_ID + '.' + BookingsRoutingRoots.DASHBOARD,
				name: BookingsRoutingRoots.DASHBOARD,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.PRELEASE + '/' + BookingsRoutingRoots.DASHBOARD
			}));
		}
		if (currentUserPermissions.hasPermissions([BookingsPermissions.bookings_prelease_can_retrieve_customer_vip_list, BookingsPermissions.bookings_relief_can_retrieve_plate_vip_list])) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_PRELEASE_MENU_ID + '.' + BookingsRoutingRoots.ANAGRAFICHE,
				name: BookingsRoutingRoots.PERSONAL_DATA,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.PRELEASE + '/' + BookingsRoutingRoots.ANAGRAFICHE
			}));
		}
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_prelease_can_retrieve_aci_list)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_PRELEASE_MENU_ID + '.' + BookingsRoutingRoots.ACI,
				name: BookingsRoutingRoots.ACI.toUpperCase(),
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.PRELEASE + '/' + BookingsRoutingRoots.ACI
			}));
		}
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_prelease_can_retrieve_rac_list)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_PRELEASE_MENU_ID + '.' + BookingsRoutingRoots.RAC,
				name: BookingsRoutingRoots.RAC,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.PRELEASE + '/' + BookingsRoutingRoots.RAC
			}));
		}
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_prelease_can_retrieve_history_list)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_PRELEASE_MENU_ID + '.' + BookingsRoutingRoots.BOOKING_HISTORY,
				name: BookingsRoutingRoots.BOOKING_HISTORY,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.PRELEASE + '/' + BookingsRoutingRoots.BOOKING_HISTORY
			}));
		}
		items.push(new ItemMenu({ // wave 1
			id: UserV3Model.BOOKINGS_PRELEASE_MENU_ID + '.' + BookingsRoutingRoots.RESERVATION_LIST,
			name: BookingsRoutingRoots.RESERVATION_LIST,
			routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.PRELEASE + '/' + BookingsRoutingRoots.RESERVATION_LIST
		}));
		if (currentUserPermissions.hasPermissions(BookingsPermissions.bookings_prelease_can_retrieve_settings)) {
			items.push(new ItemMenu({
				id: UserV3Model.BOOKINGS_PRELEASE_MENU_ID + '.' + BookingsRoutingRoots.SETTINGS,
				name: BookingsRoutingRoots.SETTINGS,
				routerLink: '/' + ROOT_BOOKINGS + '/' + BookingsRoutingRoots.PRELEASE + '/' + BookingsRoutingRoots.SETTINGS
			}));
		}
		return items;
	}

	static getItemsMenuCargos(currentUserPermissions: UserPermissionsModel): ItemMenu[] {
		const items: any = [];

		items.push(new ItemMenu({
			id: UserV3Model.CARGOS_ITEM_MENU_ID + '.' + DL_CARGOS_LIST,
			name: DL_CARGOS +"_"+DL_CARGOS_LIST,//Lista Cargos
			routerLink: '/' + DL_CARGOS + '/' + DL_CARGOS_LIST
		}));
		
		return items;
	}


	constructor(private appConfig: AppConfigEnvironmentService) {
		LoginRequestService.env = appConfig.Environment;
	}
}
